/* eslint-disable */
/*
* people.js
*
* Description: Holds 'Stores' Logic for Module:'People'.
*
* This file is part of: "http://apps.sundair.com/", "SunCrew - People"
* Copyright 2018,2019,2020 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Learek <michael.broeker@sundair.com>
*
*/
import Vue from 'vue';
import axios from 'axios';

import { eventBus } from '../../../main';


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const state = {

    // >>> people -----------------------------------------
    people_resourcesOfDepartment: [],
    people_resources_Filtered: [],

    // >>> people - search/filter ------------------------- e. defaults
    people_searchTerms: {
        "bases": [],
        "funzioni": [],
        "departments": ["Cabin", "Cockpit"],
        "positions": [],
        "status": ["Active"]
    },
    people_filterTerm: null,

    // >>> people - crews ---------------------------------
    people_crewsOnAirplane: []
};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
const getters = {

    /***************************************************************************
    * Getters: 'People' - Load Department(s)
    ***************************************************************************/
    /***************************************************************************
    * get_ResourcesOfDepartment()
    *
    * Desc:
    * Note:
    *
    */
    get_ResourcesOfDepartment: state => {

        return state.people_resourcesOfDepartment;

    }, // eof get_ResourcesOfDepartment()


    /***************************************************************************
    * get_Resources_Filtered()
    *
    * Desc:
    * Note:
    *
    */
    get_Resources_Filtered: state => {

        return state.people_resources_Filtered;

    }, // eof get_Resources_Filtered()


    /***************************************************************************
    * get_Resources_3LC()
    *
    * Desc:
    * Note:
    *
    */
    get_Resources_3LC: state => {

        let listOf3LCs = [];


        state.people_resourcesOfDepartment.forEach(resource => {
            listOf3LCs.push(resource.contract3Code);
        });

        return listOf3LCs;

    }, // eof get_Resources_3LC()




    /***************************************************************************
    * Getters: 'People' - SearchTerms
    ***************************************************************************/
    /***************************************************************************
    * get_people_searchTerms()
    *
    * Desc:
    * Note:
    *
    */
    get_people_searchTerms: state => {

        return state.people_searchTerms;

    }, // eof get_people_searchTerms()



    /***************************************************************************
    * Getters: 'People' - Crews
    ***************************************************************************/
    /***************************************************************************
    * get_people_crewsOnAirplane()
    *
    * Desc:
    * Note:
    *
    */
    get_people_crewsOnAirplane: state => {

        return state.people_crewsOnAirplane;

    }, // eof get_people_crewsOnAirplane()

};




//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const mutations = {

    /***************************************************************************
    * Mutations: 'People' - Load Department(s)
    ***************************************************************************/
    /***************************************************************************
    * mut_reset_ResourcesOfDepartment()
    *
    * Desc: Reset
    * Note:
    *
    */
    mut_reset_ResourcesOfDepartment: (state, payload) => {

        state.people_resourcesOfDepartment = [];
        state.people_resources_Filtered = [];

        state.people_searchTerms = {
            "bases": [],
            "funzioni": [],
            "departments": ["Cabin", "Cockpit"],
            "positions": [],
            "status": ["Active"]
        };
        state.people_filterTerm= null;

    }, // eof mut_reset_ResourcesOfDepartment()

    /***************************************************************************
    * mut_set_ResourcesOfDepartment()
    *
    * Desc: Set Resources of Department from Calls Reponse.
    * Note: There are to simultaneously Department Calls.
    * Note: Therefore this is a 'stupid' Hack here.
    * Note: Build 'filterableName'.
    *
    */
    mut_set_ResourcesOfDepartment: (state, payload) => {

        let filterableName = null,
            fullName = null;


        if (state.people_resourcesOfDepartment.length === 0) { // first load
            state.people_resourcesOfDepartment = payload.response;
        } else {
            state.people_resourcesOfDepartment = state.people_resourcesOfDepartment.concat(payload.response);
        }
        state.people_resources_Filtered = state.people_resourcesOfDepartment;


        // >>> Add 'onKeyup_filterResources' ----
        state.people_resources_Filtered.forEach((item) => {
            filterableName = item.genLastname + ' ' + item.genFirstName + ' ' + item.contract3Code;
            item.filterableName = filterableName;
            fullName = item.genLastname + ', ' + item.genFirstName;
            item.fullName = fullName;

            item.wasEdited = false;
        });


        payload.context.commit('mut_filter_Resources');

    }, // eof mut_set_ResourcesOfDepartment()



    /***************************************************************************
    * Mutations: 'People' - Load Crew(s)
    ***************************************************************************/
    /***************************************************************************
    * mut_set_CrewsOnAirplane()
    *
    * Desc: Set Crews from Calls Reponse.
    * Note:
    *
    */
    mut_set_CrewsOnAirplane: (state, payload) => {

        state.people_crewsOnAirplane = payload.response;

    }, // eo function mut_set_CrewsOnAirplane()




    /***************************************************************************
    * Mutations: 'People' - Resource
    ***************************************************************************/
    /***************************************************************************
    * mut_call_updateCreateResource()
    *
    * Desc: Update or Create in 'people_resources_Filtered'.
    * Note: Build 'filterableName'.
    * Note: 'editorMode' decides if we have to 'update' or to 'create' (add).
    * Note: { response: response.data, editorMode: payload.editorMode }
    *
    */
    mut_call_updateCreateResource: (state, payload) => {

        let item = null,
            filterableName = null,
            fullName = null,
            people_resources_DepartmentCopy = [];


        if (payload.editorMode === 'update') {
            state.people_resourcesOfDepartment.forEach((item) => {
                if (item.id === payload.response.id) {
                    item = payload.response; // 'overwrite'

                    filterableName = item.genLastname + ' ' + item.genFirstName + ' ' + item.contract3Code;
                    item.filterableName = filterableName;
                    fullName = item.genLastname + ', ' + item.genFirstName;
                    item.fullName = fullName;

                    item.wasEdited = true;
                }
                people_resources_DepartmentCopy.push(item);
            });

            state.people_resourcesOfDepartment = people_resources_DepartmentCopy;
        }


        if (payload.editorMode === 'create') {
            item = payload.response;

            filterableName = item.genLastname + ' ' + item.genFirstName + ' ' + item.contract3Code;
            item.filterableName = filterableName;
            fullName = item.genLastname + ', ' + item.genFirstName;
            item.fullName = fullName;

            item.wasEdited = false;

            state.people_resourcesOfDepartment = state.people_resourcesOfDepartment.concat(item);
        }

        payload.context.commit('mut_filter_Resources');

    }, // eof mut_call_updateCreateResource()


    /***************************************************************************
    * mut_call_switchActiveStatus()
    *
    * Desc: Update in 'people_resources_Filtered'.
    * Note:
    *
    */
    mut_call_switchActiveStatus: (state, payload) => {

        let people_resources_DepartmentCopy = [];

        state.people_resourcesOfDepartment.forEach((item) => {
            if (item.id === payload.response.id) {
                item.active = payload.response.active;
            }

            people_resources_DepartmentCopy.push(item);
        });

        state.people_resourcesOfDepartment = people_resources_DepartmentCopy;

        payload.context.commit('mut_filter_Resources');

    }, // eof mut_call_switchActiveStatus()


    /***************************************************************************
    * mut_call_deleteResource()
    *
    * Desc: Delete Index from 'people_resources_Filtered'.
    * Note: Delete in filtered AND in original resources list.
    *
    */
    mut_call_deleteResource: (state, payload) => {

        let index_resources_Filtered = state.people_resources_Filtered.findIndex(i => i.id === payload.id),
            index_resources_Department = state.people_resourcesOfDepartment.findIndex(i => i.id === payload.id);


        if (index_resources_Filtered > -1) {
            state.people_resources_Filtered.splice(index_resources_Filtered, 1);
        }

        if (index_resources_Department > -1) {
            state.people_resourcesOfDepartment.splice(index_resources_Department, 1);
        }

    }, // eof mut_call_deleteResource()


    /***************************************************************************
    * mut_call_updateCreateBaseHistory()
    *
    * Desc: Update resource.
    * Note: On a "fresh" created resource there is no basehistory, and backend
    * Note: sends null as inital value.
    * Note: _lookUpCurrentBase returns the current base the resource in based.
    *
    */
    mut_call_updateCreateBaseHistory: (state, payload) => {

        let index_resources_Department = state.people_resourcesOfDepartment.findIndex(i => i.id === payload.response.idResource),
            currentBaseStation = null;


        if (index_resources_Department > -1) {

            if (state.people_resourcesOfDepartment[index_resources_Department].contractBaseStationHistory === null) {
                state.people_resourcesOfDepartment[index_resources_Department].contractBaseStationHistory = [];
            }

            state.people_resourcesOfDepartment[index_resources_Department].contractBaseStationHistory.push(payload.response);

            currentBaseStation = Vue.prototype.$lookUpCurrentBase(state.people_resourcesOfDepartment[index_resources_Department].contractBaseStationHistory);

            if (currentBaseStation !== null) {
                state.people_resourcesOfDepartment[index_resources_Department].contractBaseStation = currentBaseStation.idBase;
                state.people_resourcesOfDepartment[index_resources_Department].contractBaseStationCode = currentBaseStation.baseCode;
            }

        }

        payload.context.commit('mut_filter_Resources');

    }, // eof mut_call_updateCreateBaseHistory()


    /***************************************************************************
    * mut_call_deleteBaseHistory()
    *
    * Desc: Update resource.
    * Note: _lookUpCurrentBase returns the current base the resource in based.
    * Note: If it returns null, there is no base in the past till today, so
    * Note: we delete contractBaseStation and contractBaseStationCode.
    *
    */
    mut_call_deleteBaseHistory: (state, payload) => {

        let index_resources_Department = state.people_resourcesOfDepartment.findIndex(i => i.id === payload.payload.idResource),
            index_baseStationHistory = null,
            currentBaseStation = null;


        if (index_resources_Department > -1) {

            index_baseStationHistory = state.people_resourcesOfDepartment[index_resources_Department].contractBaseStationHistory.findIndex(b => b.id === payload.payload.id);

            if (index_baseStationHistory > -1) {
                state.people_resourcesOfDepartment[index_resources_Department].contractBaseStationHistory.splice(index_baseStationHistory, 1);

                currentBaseStation = Vue.prototype.$lookUpCurrentBase(state.people_resourcesOfDepartment[index_resources_Department].contractBaseStationHistory);

                if (currentBaseStation !== null) {
                    state.people_resourcesOfDepartment[index_resources_Department].contractBaseStation = currentBaseStation.idBase;
                    state.people_resourcesOfDepartment[index_resources_Department].contractBaseStationCode = currentBaseStation.baseCode;
                } else {
                    state.people_resourcesOfDepartment[index_resources_Department].contractBaseStation = null;
                    state.people_resourcesOfDepartment[index_resources_Department].contractBaseStationCode = '';
                }
            }
        }

        payload.context.commit('mut_filter_Resources');

    }, // eof mut_call_deleteBaseHistory()




    /***************************************************************************
    * Mutations: 'People' - Search/Filter
    ***************************************************************************/
    /***************************************************************************
    * mut_set_filterResources_searchTerm()
    *
    * Desc: Simply set 'people_searchTerms'.
    * Note:
    *
    */
    mut_set_filterResources_searchTerm: (state, payload) => {

        state.people_searchTerms = payload;

    }, // eof mut_set_filterResources_searchTerm()


    /***************************************************************************
    * mut_set_filterResources_filterTerm()
    *
    * Desc: Simply set 'people_filterTerm'.
    * Note:
    *
    */
    mut_set_filterResources_filterTerm: (state, payload) => {

        state.people_filterTerm = payload;

    }, // eof mut_set_filterResources_filterTerm()


    /***************************************************************************
    * mut_filter_Resources()
    *
    * Desc: (Re)build 'new' people_resources_Filtered.
    * Note:
    *
    */
    mut_filter_Resources: (state) => {

        const filterBases = (resource) => {
            let applyFilter = false;

            if (state.people_searchTerms && state.people_searchTerms.bases.length > 0) {
                if (state.people_searchTerms.bases.includes(resource.contractBaseStation)) {
                    applyFilter = true;
                }
            }

            // if there is set no search term
            if (state.people_searchTerms && state.people_searchTerms.bases.length === 0) {
                applyFilter = true;
            }

            if (state.people_searchTerms === null) {
                applyFilter = true;
            }

            return applyFilter;
        };

        const filterDepartments = (resource) => {
            let applyFilter = false,
                includesCabin,
                includesCockpit;

            if (state.people_searchTerms && state.people_searchTerms.departments.length > 0) {

                includesCabin = state.people_searchTerms.departments.includes('Cabin');
                includesCockpit = state.people_searchTerms.departments.includes('Cockpit');


                if (includesCabin === true && includesCockpit === true) {
                    applyFilter = true;
                } else if (includesCabin === true && includesCockpit === false) {
                    if (resource.idHrDepartment === 11) {
                        applyFilter = true;
                    }
                } else if (includesCabin === false && includesCockpit === true) {
                    if (resource.idHrDepartment === 12) {
                        applyFilter = true;
                    }
                } else if (includesCabin === false && includesCockpit === false) {
                    applyFilter = false;
                }
            }

            if (state.people_searchTerms === null) {
                applyFilter = true;
            }

            return applyFilter;
        };

        const filterStatus = (resource) => {
            let applyFilter = false,
                includesActive,
                includesInactive;

            if (state.people_searchTerms && state.people_searchTerms.status.length > 0) {

                includesActive = state.people_searchTerms.status.includes('Active');
                includesInactive = state.people_searchTerms.status.includes('Inactive');


                if (includesActive === true && includesInactive === true) {
                    applyFilter = true;
                } else if (includesActive === true && includesInactive === false) {
                    if (resource.active === true) {
                        applyFilter = true;
                    }
                } else if (includesActive === false && includesInactive === true) {
                    if (resource.active === false) {
                        applyFilter = true;
                    }
                } else if (includesActive === false && includesInactive === false) {
                    applyFilter = false;
                }
            }

            if (state.people_searchTerms === null) {
                applyFilter = true;
            }

            return applyFilter;
        };

        const filterFunzioni = (resource) => {
            let applyFilter = false;

            if (state.people_searchTerms && state.people_searchTerms.funzioni.length > 0) {
                if (state.people_searchTerms.funzioni.includes(resource.contractAddFunction)) {
                    applyFilter = true;
                }
            }

            // if there is set no search term
            if (state.people_searchTerms && state.people_searchTerms.funzioni.length === 0) {
                applyFilter = true;
            }

            if (state.people_searchTerms === null) {
                applyFilter = true;
            }

            return applyFilter;
        };

        const filterPosition = (resource) => {
            let applyFilter = false;

            if (state.people_searchTerms && state.people_searchTerms.positions.length > 0) {
                if (state.people_searchTerms.positions.includes(resource.contractFunction)) {
                    applyFilter = true;
                }
            }

            // if there is set no search term
            if (state.people_searchTerms && state.people_searchTerms.positions.length === 0) {
                applyFilter = true;
            }

            if (state.people_searchTerms === null) {
                applyFilter = true;
            }

            return applyFilter;
        };

        const filterFilterTerm = (resource) => {
            let applyFilter = false;

            if (state.people_filterTerm && state.people_filterTerm.length > 0) {
                if (resource.filterableName.match(new RegExp(state.people_filterTerm, 'i'))) {
                    applyFilter = true;
                }
            }

            // if there is set no search term
            if (state.people_filterTerm === null || state.people_filterTerm.length === 0) {
                applyFilter = true;
            }

            return applyFilter;
        };


        state.people_resources_Filtered = state.people_resourcesOfDepartment.filter(resource => filterBases(resource));
        state.people_resources_Filtered = state.people_resources_Filtered.filter(resource => filterDepartments(resource));
        state.people_resources_Filtered = state.people_resources_Filtered.filter(resource => filterStatus(resource));
        state.people_resources_Filtered = state.people_resources_Filtered.filter(resource => filterFunzioni(resource));
        state.people_resources_Filtered = state.people_resources_Filtered.filter(resource => filterPosition(resource));
        state.people_resources_Filtered = state.people_resources_Filtered.filter(resource => filterFilterTerm(resource));

    }, // eof mut_filter_Resources()

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
const actions = {

    /***************************************************************************
    * Actions: 'People' - Load Department(s)
    ***************************************************************************/
    /***************************************************************************
    * Call::'humanresources/resource/department/' + idDepartment;
    *
    * Desc: CaLl: Get List of Departments Ressources.
    * Note: There are to simultaneously Department Calls.
    * Note: Therefore thjis stupid Hack here.
    * Note: e.g.: payload => { department: '12', secondLoad: true }
    *
    */
    actn_call_getResourcesOfDepartment: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        if (!payload.secondLoad) {
            Vue.prototype.$vp_m();
            context.commit('mut_reset_ResourcesOfDepartment'); // reset
        }

        axios.get('/humanresources/resource/department/' + payload.department)
            .then(function (response) { // 'OK'
                if (payload.secondLoad) {
                    Vue.prototype.$vp_um();
                }
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_set_ResourcesOfDepartment', { response: response.data, secondLoad: payload.secondLoad, context: context });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                if (payload.secondLoad) {
                    Vue.prototype.$vp_um();
                }
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getResourcesOfDepartment()


    /***************************************************************************
    * Actions: 'Crews' - Load Crew(s)
    ***************************************************************************/
    /***************************************************************************
    * Call::'humanresources/crew/';
    *
    * Desc: Call: Get List of Crews.
    * Note:
    *
    */
    actn_call_people_getCrewsOnAirplane: (context) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        axios.get('/humanresources/crew/')
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_set_CrewsOnAirplane', { response: response.data, context: context });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getCrewsOnAirplane()




    /***************************************************************************
    * Actions: 'People' - Resource
    ***************************************************************************/
    /***************************************************************************
    * Call::'/humanresources/resource'
    *
    * Desc: Call: Update/Create Resource.
    * Note: Difference is: Payload has 'id' (update) or no 'id' (create).
    *
    */
    actn_call_updateCreateResource: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/resource';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put(url, payload.payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_updateCreateResource', { response: response.data, editorMode: payload.editorMode, context: context });
                        eventBus.$emit('resourceswasupdatedcreated'); // emit ..
                        Vue.prototype.$toasted.global.sdr_app_info({ // inform
                            message: 'Record was updated/created.'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_updateCreateResource()


    /***************************************************************************
    * Call::'/humanresources/resource'
    *
    * Desc: Call: Delete Resource.
    * Note: Payload is 'id' (Resource Id).
    *
    */
    actn_call_deleteResource: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/resource/' + payload;


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.delete(url)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_deleteResource', response.data);
                        Vue.prototype.$toasted.global.sdr_app_info({ // inform
                            message: 'Record was deleted.'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_deleteResource()


    /***************************************************************************
    * Call::'/humanresources/resource'
    *
    * Desc: Call: Update/Create Resource.
    * Note: Difference is: Payload has 'id' (update) or no 'id' (create).
    *
    */
    actn_call_switchActiveStatus: (context, payload) => {

        let hdrs = '',
            url = `/humanresources/resource/status/${payload.idResource}/${payload.status}`;


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.get(url, payload.payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_switchActiveStatus', { response: response.data, context: context });
                        Vue.prototype.$toasted.global.sdr_app_info({ // inform
                            message: 'Record was updated.'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_updateCreateResource()


    /***************************************************************************
    * Call::'/humanresources/resource/basehistory'
    *
    * Desc: Call: Update (Add) a Base History Entry.
    * Note:
    *
    */
    actn_call_updateCreateBaseHistory: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/resource/basehistory';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put(url, payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_updateCreateBaseHistory', { response: response.data, context: context });
                        Vue.prototype.$toasted.global.sdr_app_info({ // inform
                            message: 'Record was updated.'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_updateCreateResource()



    /***************************************************************************
    * Call::'/humanresources/resource/basehistory'
    *
    * Desc: Call: Delete a Base History Entry.
    * Note:
    *
    */
    actn_call_deleteBaseHistory: (context, payload) => {

        let hdrs = '',
            url = `/humanresources/resource/basehistory/${payload.id}`;


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.delete(url)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_deleteBaseHistory', { payload: payload, context: context });
                        Vue.prototype.$toasted.global.sdr_app_info({ // inform
                            message: 'Record was updated.'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_deleteBaseHistory()




    /***************************************************************************
    * Actions: 'People' - Search/Filter
    ***************************************************************************/
    /***************************************************************************
    * actn_set_filterResources_searchTerm
    *
    * Desc: Set 'search Terms' and 'refilter'.
    * Note:
    *
    */
    actn_set_filterResources_searchTerm: (context, payload) => {

        context.commit('mut_set_filterResources_searchTerm', payload);
        context.commit('mut_filter_Resources');

    }, // eo function actn_set_filterResources_searchTerm()


    /***************************************************************************
    * actn_set_filterResources_filterTerm()
    *
    * Desc: Set 'filter Terms' and 'refilter'.
    * Note:
    *
    */
    actn_set_filterResources_filterTerm: (context, payload) => {

        context.commit('mut_set_filterResources_filterTerm', payload);
        context.commit('mut_filter_Resources');

    }, // eo function actn_set_filterResources_filterTerm()





    /***************************************************************************
    * Actions: 'Reports' - Download: 'People Report'
    ***************************************************************************/
    /***************************************************************************
    * Call::'/rest/humanresources/resource/report'
    *
    * Desc:
    *
    */
    actn_call_download_PeopleReport: (context, payload) => {

        let url = '/rest/humanresources/resource/report';
        let xhr = new XMLHttpRequest();


        xhr.open("GET", url);
        xhr.setRequestHeader("apiKey", '037ae1f2ba244a2a93b24121743bfdd6');
        xhr.setRequestHeader("Authorization", payload.authheader);
        xhr.responseType = "arraybuffer";

        xhr.onload = function () {
            if (this.status === 200) {
                // var blob = new Blob([xhr.response], { type: "application/csv" });
                // var objectUrl = URL.createObjectURL(blob);

                // // Create a hidden link and set its href to the blob URL and download attribute to desired filename
                // var link = document.createElement('a');
                // link.href = objectUrl;
                // link.download = 'people_report.csv'; // replace 'desired_filename.csv' with the filename you want
                // link.style.display = 'none';

                // // Append the link to the body and programmatically click it
                // document.body.appendChild(link);
                // link.click();

                // // Clean up by removing the link
                // document.body.removeChild(link);





                // Decode response using UTF-8
                let dataView = new DataView(this.response);
                let decoder = new TextDecoder('utf-8'); // specify encoding here
                let responseText = decoder.decode(dataView);

                // Convert the decoded response to Blob
                var blob = new Blob([responseText], { type: "application/csv" });
                var objectUrl = URL.createObjectURL(blob);

                // Create a hidden link and set its href to the blob URL and download attribute to desired filename
                var link = document.createElement('a');
                link.href = objectUrl;
                link.download = 'people_report.csv'; // replace 'desired_filename.csv' with the filename you want
                link.style.display = 'none';

                // Append the link to the body and programmatically click it
                document.body.appendChild(link);
                link.click();

                // Clean up by removing the link
                document.body.removeChild(link);

            }
        };
        xhr.send();

    }, // eo function actn_call_download_PeopleReport()

};





//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default {
    state,
    getters,
    mutations,
    actions,
};